export default "__VITE_ASSET__Cyuf$3LH__"